import React, { useContext, useEffect, useState } from "react";
import NewFileCard from "./NewFileCard";
import FileContext from "../../../context/files/FileContext";
import NotificationToast from "../../common/NotificationToast";


const FileList = () => {
  const [newFiles, setNewFiles] = useState([]);
  const [uploadSuccessMessage, setUploadSuccessMessage] = useState(false);
  const fileContext = useContext(FileContext);
  const {
    uploadFilesLoading,
    uploadFilesResult,
    uploadFilesError
  } = fileContext

  // Add new file
  const handleAddFileClick = () => {
    const values = [...newFiles];
    values.push({ file: null, description: "" });
    setNewFiles(values);
  }

  // Delete new file
  const handleRemove = (index) => {
    const values = [...newFiles];
    values.splice(index, 1);

    setNewFiles(values);
  }

  const onFileChange = async (e, index) => {
    const file = e.target.files[0];
    newFiles[index] = {
      ...newFiles[index],
      file
    };

    setNewFiles([...newFiles]);
  };

  const onDescriptionChange = (e, index) => {
    let { value } = e.target;
    // Replace . with empty strings
    value = value.replace('.', '');
    newFiles[index] = {
      ...newFiles[index],
      description: value
    };

    setNewFiles([...newFiles]);
  }

  const handleUploadClick = () => {
    fileContext.uploadFiles(newFiles);
  };

  useEffect(() => {
    if (uploadFilesResult) {
      setUploadSuccessMessage(true);
      setNewFiles([]);
    };
  }, [uploadFilesError, uploadFilesResult])

  return (
    <div style={{ paddingTop: 12, paddingBottom: 12 }}>
      <NotificationToast
        open={uploadSuccessMessage}
        handleClose={() => setUploadSuccessMessage(false)}
        text='Files uploaded successfuly!'
      />
      {/* {message ? <Message msg={message} /> : null} */}
      {newFiles.map((newFile, index) => {
        return (
          <NewFileCard
            file={newFile}
            onFileChange={onFileChange}
            onDescriptionChange={onDescriptionChange}
            index={index}
            key={index}
            handleAddFileClick={handleAddFileClick}
            handleRemove={handleRemove}
          />
        );
      })}

      <div style={{
        width: 'fit-content',
        margin: '16px auto 16px auto'
      }}>
        <button
          className="btn btn-sm btn-primary"
          style={{ width: 120 }}
          type="button"
          onClick={handleAddFileClick}>
          + Add file
        </button>
      </div>

      {uploadFilesError &&
        <div className='text-danger' style={{ padding: 12 }}>
          {uploadFilesError}
        </div>
      }

      {newFiles.length > 0 &&
        <button
          disabled={uploadFilesLoading}
          onClick={handleUploadClick}
          className="btn btn-sm btn-primary"
          style={{ width: 120 }}>
          {uploadFilesLoading ? 'Uploading...' : 'Upload'}
        </button>
      }
    </div>
  );
};

export default FileList;
